import React from 'react';

const ReviewsPrimary = ({ productID }) => (
  <div data-bv-show="reviews" data-bv-product-id={productID} />
);

export default ReviewsPrimary;
